export default __webpack_public_path__ + "static/hotel-compare-5bd4f08825648e62bf7687c198f1529e.png";